import { render, staticRenderFns } from "./PgaAlertWarning.vue?vue&type=template&id=45f44bec&"
import script from "./PgaAlertWarning.vue?vue&type=script&lang=ts&"
export * from "./PgaAlertWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VOverlay,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45f44bec')) {
      api.createRecord('45f44bec', component.options)
    } else {
      api.reload('45f44bec', component.options)
    }
    module.hot.accept("./PgaAlertWarning.vue?vue&type=template&id=45f44bec&", function () {
      api.rerender('45f44bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaAlertWarning.vue"
export default component.exports